<template>
  <div class="banner d-flex align-center h-100 py-12 px-14">
    <div class="banner-content d-flex flex-column align-start ga-8">
      <div class="banner-text d-flex flex-column ga-4 text-white">
        <div class="banner-title font-weight-bold" data-testid="login-banner-title">
          {{ $t("login.banner.title") }}
        </div>
        <div
          class="banner-body"
          data-testid="login-banner-body"
          v-html="$t('login.banner.body')"
        ></div>
      </div>
      <v-btn
        rounded
        height="44"
        class="banner-report-btn text-uppercase font-weight-bold bg-white text-primary"
        data-testid="login-banner-report-btn"
        :href="CoroMarketingLink.GARTNER_WORKSPACE_REPORT"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t("login.banner.readReportBtn") }}
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { CoroMarketingLink } from "@/constants/general";

export default defineComponent({
  setup() {
    return {
      CoroMarketingLink,
    };
  },
});
</script>

<style scoped lang="scss">
.banner {
  background: rgb(var(--v-theme-primary)) url("/images/login-banner-gartner.webp") center / cover
    no-repeat;
}

.banner-content {
  width: 400px;
}

.banner-text {
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.35);
}

.banner-title {
  font-size: 40px;
  line-height: 110%;
  letter-spacing: -0.3px;
}

.banner-body {
  max-width: 320px;
  font-size: 18px;
  line-height: 140%;
}

.banner-report-btn {
  --v-hover-opacity: 0.12;
}
</style>
